export const UPDATE_CURRENT_TYPE = "UPDATE_CURRENT_TYPE";
export const UPDATE_DATE_RANGE = "UPDATE_DATE_RANGE";
